module.exports = __webpack_public_path__ + "static/media/bg.63a987f0.png";